import { handleSort } from "./handleSort";
import { Dispatch } from "redux";
import { QualificationListSortEnum } from "../../../common/enums/QualificationListSortEnum";
import { PrimaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";

interface Args {
    isEstablishmentManager: boolean;
    sort: {
        sortName: string;
        isSorted: boolean;
    };
    dispatch: Dispatch;
}

export const getQualificationTableHeadColumns = (
    args: Args,
): PrimaryTableColumn[] => {
    const { sort, dispatch, isEstablishmentManager } = args;

    return [
        {
            value: "",
        },
        {
            value: "Kwalificatie",
            isSortable: true,
            isSorted:
                sort.sortName === QualificationListSortEnum.QUALIFICATION_DESC,
            sortOnClick: handleSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        QualificationListSortEnum.QUALIFICATION_DESC,
                    sortName: QualificationListSortEnum.QUALIFICATION,
                },
                dispatch,
            }),
        },
        ...(isEstablishmentManager
            ? [
                  {
                      value: "Type",
                      isSortable: true,
                      isSorted:
                          sort.sortName === QualificationListSortEnum.TYPE_DESC,
                      sortOnClick: handleSort({
                          sort: {
                              isSorted:
                                  sort.sortName ===
                                  QualificationListSortEnum.TYPE_DESC,
                              sortName: QualificationListSortEnum.TYPE,
                          },
                          dispatch,
                      }),
                  },
              ]
            : []),
        {
            value: "Functiegroep",
            isSortable: false,
            isTag: true,
            tagColor: "#1D2D58",
            tagBackgroundColor: "#DAEBA8",
        },
        {
            value: "Norm",
            isSortable: false,
            isTag: true,
            tagColor: "#FFFFFF",
            tagBackgroundColor: "#07A9D6",
        },
        {
            value: "Geldigheidsduur",
            isSortable: false,
        },
        ...(isEstablishmentManager
            ? [
                  {
                      value: "Aantal",
                      isSortable: false,
                  },
              ]
            : []),
    ];
};
